export default __webpack_public_path__ + "static/char-s-58-en-a37c6b6402106d585d3da089d422fd7c.webp";